import { CommonError } from './CommonError';

export class AuthError extends CommonError {
  constructor(message: string) {
    super('AuthError', message);
  }
}
